export enum Language {
  english = 'en',
  swedish = 'sv',
}
